import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Coel Advocaten Publications"}
                    description={"A list of books and press articles published by members of the law firm Coel Advocaten."}
                    url={"https://www.coeladvocaten.be/en/publications"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/publicaties", language:"nl" },
                        { url:"https://www.coeladvocaten.be/en/publications", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/publicaties"
                />
                
                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-publications"></div>
                        <div className="slider">
                            <h1>Publications</h1>
                            <h2>Coel Advocaten</h2>
                            <p></p>
                            <a href="/en/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="team">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-2"></div>
                                <div className="col-lg-8">
                                    <div className="cell">
                                        <div className="image">
                                            <img src="/static/images/ons-team-frank-thumb.jpg" alt="Frank Coel, administrative law, family law, business law, criminal law" />
                                        </div>
                                        <h3>Frank Coel</h3>
                                        <ul>
                                            <li>Introduction to Migration Law, Bruges, Die Keure, 2002</li>
                                            <li>Various thematic articles for specialized journals</li>
                                            <li>Since 1990 repeatedly speaker and guest lecturer for study days at the request of the UA, the OVB and the Mechelen Bar Association</li>
                                            <li>Member of various commissions within the Order of Flemish Bars</li>
                                            <li>Member of the Complaints Commission for Closed Centers</li>
                                            <li>Sitting member of the disciplinary council on appeal</li>
                                            <li>Former member of the Mechelen Bar Council, member of the tax commission and treasurer of the Mechelen Bar Association</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-2"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
